export default "__VITE_ASSET__Hu3crJrB__"